import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button, Form, Input } from 'semantic-ui-react';

import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import CompetitionFieldMain from '../Account/Forms/CompetitionFieldMain';
import { PasswordInput } from '../Forms';
import { AltchaCaptchaPortalTarget } from '../../containers/Altcha/AltchaWidget';

interface AuthContentProps {
  agreeCompetitionValue: boolean;
  allFilled: boolean;
  competition: any;
  competitionId: string;
  competitionName: string;
  email: string;
  errors: { email: string; currentPassword: string };
  handleBlur: (dataInfo: any) => void;
  handleChange: (event: any, data: any) => void;
  handleCleanCaptcha: () => void;
  handlePasswordKeyUp: (event: any) => void;
  handleSignUp: () => void;
  handleUserLogin: (event: any) => void;
  isCapsLockOn: boolean;
  password: string;
}

export const AuthenticationContentWithoutIntl = ({
  agreeCompetitionValue,
  allFilled,
  competition,
  competitionId,
  competitionName,
  email,
  errors,
  handleBlur,
  handleChange,

  handlePasswordKeyUp,

  handleSignUp,
  handleUserLogin,
  intl,
  isCapsLockOn,
  password,
}: AuthContentProps & InjectedIntlProps) => {
  return (
    <div className="auth__container">
      <form onSubmit={handleUserLogin} className="auth__content">
        <Form.Field className="form__field form__authentication">
          <label htmlFor="email" className="form__label">
            {' '}
            <FormattedMessageHelper id="authenticationMain.email" />
          </label>
          <Input
            id="email"
            autoFocus={true}
            className="form__input"
            type="email"
            value={email}
            name="email"
            onChange={handleChange}
            onBlur={handleBlur}
            required={true}
            autoComplete="email"
          />
          <div className="input__error">
            {errors.email !== '' && (
              <div className="error">
                <FormattedMessageHelper id={errors.email} />
              </div>
            )}
          </div>
        </Form.Field>
        <Form.Field className="form__field form__authentication">
          <label htmlFor="password" className="form__label">
            <FormattedMessageHelper id="authenticationMain.password" />
          </label>
          <PasswordInput
            id="password"
            className="form__input"
            value={password}
            name="currentPassword"
            onChange={handleChange}
            onKeyUp={handlePasswordKeyUp}
            autoComplete="on"
          />
          <div className="input__error">
            {errors.currentPassword !== '' && (
              <div className="error">
                <FormattedMessageHelper id={errors.currentPassword} />
              </div>
            )}
            {isCapsLockOn && (
              <div className="error">
                <FormattedMessageHelper id="authentication.password.capsLockOn" />
              </div>
            )}
          </div>
          <div className="auth__forgot-password">
            <Link to="/forgot-password">
              {' '}
              <FormattedMessageHelper id="authenticationMain.forgotPassword" />{' '}
            </Link>
          </div>
        </Form.Field>

        {competition && (
          <CompetitionFieldMain
            agreeCompetition={agreeCompetitionValue}
            handleChangeField={handleChange}
            logoutCompetition={competitionId}
            competitionName={competitionName}
            intl={intl}
          />
        )}
        <AltchaCaptchaPortalTarget />
        <Form.Field className="form__field form__field--button">
          <Button className="button button--lg" type="submit" disabled={!allFilled} onClick={handleUserLogin}>
            <FormattedMessageHelper id="authenticationMain.signIn" />
          </Button>
        </Form.Field>
        <div className="auth__sign-up">
          <FormattedMessageHelper id="authenticationMain.without.account" />
          &nbsp;
          <Button onClick={handleSignUp} className="btn btn-blue">
            <FormattedMessageHelper id="authenticationMain.signUp" />
          </Button>
        </div>
        <div className="auth__sign-up">
          <FormattedMessageHelper id="authenticationMain.havingTroubles" />
          &nbsp;
          <a href="mailto:support@worldquantbrain.com" className="ui button btn-blue">
            <FormattedMessageHelper id="authenticationMain.contactUs" />
          </a>
        </div>
      </form>
    </div>
  );
};

export const AuthenticationContent = injectIntl(AuthenticationContentWithoutIntl);
